import React, { useEffect } from "react";
import "./App.css";
import './i18n'; // Initialize i18n
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";
import ChatPage from "./pages/ChatPage";
import ImagePage from "./pages/ImagePage";
import VideoPage from "./pages/VideoPage";
import SettingsPage from "./pages/SettingsPage";
import SubscriptionPageWrapper from "./pages/SubscriptionPageWrapper";
import AdminDashboard from "./pages/AdminDashboard";
import MoodBoardPage from "./pages/MoodBoardPage";
import AuthCallback from "./pages/AuthCallback";

// Google OAuth Client ID - REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// Remove platform badges
const removePlatformBadges = () => {
  const selectors = [
    '#emergent-badge',
    'a[href*="emergent"]',
    'div[style*="position: fixed"][style*="bottom"]',
    'a[href*="app.emergent"]'
  ];
  
  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      if (el.textContent?.includes('Emergent') || el.id === 'emergent-badge') {
        el.remove();
      }
    });
  });
};

// Router wrapper to handle auth callback
function AppRouter() {
  const location = useLocation();
  
  // Remove badges on mount and route changes
  useEffect(() => {
    removePlatformBadges();
    const interval = setInterval(removePlatformBadges, 1000);
    return () => clearInterval(interval);
  }, [location]);
  
  // Check URL fragment for session_id - must be synchronous to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/dashboard" element={<Dashboard />}>
        <Route index element={<ImagePage />} />
        <Route path="chat" element={<ChatPage />} />
        <Route path="chat/:chatId" element={<ChatPage />} />
        <Route path="images" element={<ImagePage />} />
        <Route path="moodboard" element={<MoodBoardPage />} />
        <Route path="videos" element={<VideoPage />} />
        <Route path="subscription" element={<SubscriptionPageWrapper />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="admin" element={<AdminDashboard />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
